import { Control, FieldPath, FieldPathValue, FieldValues, useWatch } from 'react-hook-form';

import { usePrevious } from '#hooks/usePrevious';

export const useFieldValue = <
  TFieldValues extends FieldValues = FieldValues,
  TFieldName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  name: TFieldName,
  control: Control<TFieldValues>
): [FieldPathValue<TFieldValues, TFieldName>, FieldPathValue<TFieldValues, TFieldName>] => {
  const value = useWatch({ name, control });
  const prevValue = usePrevious(value);

  return [value, prevValue];
};
